import React from 'react';
import { TextField, Typography, Box } from '@mui/material';

const NumberQuestion = ({ question, questionNumber, answer, onAnswerChange }) => {
  const handleChange = (event) => {
    const { value } = event.target;

    // Regex to allow numbers with up to 2 decimals and a comma as the decimal separator
    const roundToTwoPattern = /^$|^[0-9]+(,[0-9]{0,2})?$/;

    if (!roundToTwoPattern.test(value)) {
      return; // Prevent invalid input
    }

    // Convert the value to a number for comparison (replace comma with a dot for parsing)
    const numericValue = parseFloat(value.replace(',', '.'));

    // Check if the value exceeds the maximum allowed
    if (question.max !== undefined && numericValue > question.max) {
      return; // Prevent input larger than the maximum
    }

    onAnswerChange(value); // Update the answer
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="body1">
        {questionNumber}. {question.text}
      </Typography>
      <TextField
        value={answer || ""}
        placeholder={question.placeholder}
        onChange={handleChange}
        fullWidth
        margin="normal"
        slotProps={{input: {readOnly: onAnswerChange === null}}}
      />
    </Box>
  );
};

export default NumberQuestion;